import styles from './CategoryTimer.scss';
import { t } from '~/utils/localization';
import classNames from 'classnames';
import CountDown from '~/components/CountDown/CountDown';

interface ICategoryTimer {
    category: ICategory;
    title?: string;
    onComplete?: DefaultFunction;
    className?: string;
}

const CategoryTimer = ({ category, title, className, onComplete }: ICategoryTimer) => {
    return (
        <div className={classNames(styles.wrapper, styles[category.theme], styles[category.type], className)} key={category.name}>
            <div className={styles.title}>
                <span className={styles.label} dangerouslySetInnerHTML={{ __html: title || t('До конца события') }} />
            </div>
            <div className={styles.timer}>
                <CountDown date={category?.activeTill} isLarge={true} onComplete={onComplete} />
            </div>
        </div>
    );
};

export default CategoryTimer;
